import classNames from "classnames";
import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

type TimelineItemRootNode = HTMLLIElement;

interface TimelineItemProps extends React.HTMLAttributes<TimelineItemRootNode> {}

const TimelineItem = forwardRef<TimelineItemRootNode, TimelineItemProps>(({ className, ...props }, ref) => {
  return <li className={twMerge(classNames("ml-4 flex w-full items-center", className))} ref={ref} {...props} />;
});

TimelineItem.displayName = TimelineItem.name;

export default TimelineItem;
